
import { Component, Prop, Vue } from 'vue-property-decorator';
import WorkCarouselStadia from '@/components/work-carousel-stadia.vue';
import WorkCarouselYouTube from '@/components/work-carousel-youtube.vue';
import WorkCarouselEarth from '@/components/work-carousel-earth.vue';
import WorkCarouselQiblaFinder from '@/components/work-carousel-qibla-finder.vue';
import WorkCarouselPetra from '@/components/work-carousel-petra.vue';
import WorkCarouselCloudBlog from '@/components/work-carousel-cloud-blog.vue';

@Component({
  components: {
    WorkCarouselStadia,
    WorkCarouselYouTube,
    WorkCarouselEarth,
    WorkCarouselQiblaFinder,
    WorkCarouselPetra,
    WorkCarouselCloudBlog,
  },
})
export default class Work extends Vue {
  tenure = 3;
  currentWork = 'google-stadia';
  @Prop() isResizing?: boolean;

  private startYear = 2013;
  private currentYear = new Date().getFullYear();

  setWork(work: string) {
    this.currentWork = work;
  }

  private mounted() {
    this.tenure = this.yearsSince_(this.startYear, this.currentYear);
  }

  private yearsSince_(date1: number, date2: number): number {
    return date2 - date1;
  }

  private getWork(): string {
    return this.currentWork;
  }
}
